import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import StatesManager from "Engine/base/states/StatesManager";
import * as PIXI from "pixi.js";

export default class BaseUiMobileContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
        this.visible = false;
    }

    init() {
        this.uiContainer = this.getChildByName('uiContainer');
    }

    addListeners() {
        GlobalDispatcher.add('scaleManager:resize', this.onGameResized, this, 1000);

        GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
        GlobalDispatcher.add('model:betChanged', this.onBetChanged, this);
        GlobalDispatcher.add('model:autoPlayChanged', this.onAutoPlayChanged, this);
        GlobalDispatcher.add('model:balanceChanged', this.onBalanceChanged, this);
        GlobalDispatcher.add('ui:openAutoPlayPopup', this.onOpenAutoPlayPanel, this);
        GlobalDispatcher.add('paytable:closed', this.onPaytableClosed, this);

        GlobalDispatcher.add('gameSettings:soundMute', this.onSoundMute, this);
        GlobalDispatcher.add('gameSettings:quickSpin', this.onQuickSpin, this);

        GlobalDispatcher.add('overlay:showed', this.onOverlayShowed, this);
        GlobalDispatcher.add('overlay:hided', this.onOverlayHided, this);
        //GlobalDispatcher.add('popupContainer:popupHided', this.onPopupHided, this);
    }

    onGameResized(event) {
        //this.x = 0;
        let frameIndex = 1;
        if (event.params.canvasWidth > event.params.canvasHeight) {
            frameIndex = 2;
        }

        frameIndex = PIXI.utils.isMobile.tablet ? 2 : frameIndex;

        this.goToFrame(frameIndex);
        this.init();

        if (PIXI.utils.isMobile.tablet) {
            this.uiContainer.scale.set(1, 1);
        }

        this.uiContainer.onGameResized(event);
    }

    onStateChanged(event) {
        if (event.params === 'idleState') {
            this.visible = true;
        }
        this.uiContainer.onStateChanged(event);
    }

    onBetChanged(event) {
        if(EntryPoint.GameModel.freeBets) {
            return;
        }
        this.uiContainer.onBetChanged(event);
    }

    onAutoPlayChanged(event) {
        this.uiContainer.onAutoPlayChanged(event);
    }

    onBalanceChanged(event) {
        this.uiContainer.onBalanceChanged(event);
    }

    onOpenAutoPlayPanel(event) {
        this.uiContainer.onOpenAutoPlayPanel(event);
    }

    onPaytableClosed(event) {
        this.uiContainer.onPaytableClosed(event);
    }

    onSoundMute(event) {
        this.uiContainer.onSoundMute(event);
    }

    onQuickSpin(event) {
        this.uiContainer.onQuickSpin(event);
    }

    onOverlayShowed(event) {
        this.uiContainer.onOverlayShowed(event);
    }

    onOverlayHided(event) {
        this.uiContainer.onOverlayHided(event);
    }

    /*onPopupHided() {
        this.uiContainer.onStateChanged({params:StatesManager.currentState.stateData.name});
    }*/
}
